import { render, staticRenderFns } from "./module_form.html?vue&type=template&id=2e3dbcda&"
import script from "./AddModule.vue?vue&type=script&lang=js&"
export * from "./AddModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports